import { ISkeletonData, ITrackEntry, Spine } from "@modules/pixi-spine";

import { LoadingStage, IWriteOnlyResourceManager, IReadOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { JSONResource } from "../../ResourceManager/JSONResource";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { ISpineTrackAnimation } from "./IGenericFamilySpine";
import { Resourceful, Resourceful2 } from "../../ResourceManager/Resourceful";
import { AudioManager, Track } from "../../AudioManager";
import { AtlasResource } from "../../ResourceManager/AtlasResource";
import { Settings } from "../../Settings";
import { Safe, Scale, shuffle } from "../../MyHelpers";
import { IRandomTimeout } from "../../Context/RandomTimeout";
import { ISystemContext, SystemContext } from "../../Context/SystemContext";
import { ITimeout } from "../../Context/Timeout";
import { service } from "../../services";
import { LoadFinishedInfo } from "../../api";
import { ClientState } from "../../ClientState";
import { Text } from "@modules/pixi.js/lib";

enum AudioRandomType {
    "frequently" = "frequently",
    "not_frequently" = "not_frequently", 
    "disabled" = "disabled",
    "poppet" = "poppet", 
}

// interface RandomAnimationType {
//     anims : AnimationType[]
// }


enum AnimationRandomIndex {
    "frequently" = 2,
    "not_frequently" = 3, 
    "disabled" = -0,
    "poppet" = 5, 
}
interface AnimationType {
    name: string;
    type: "frequently" | "not_frequently" | "poppet" | "disabled";
    indexAnim : number,
}

export class RandomAnimationFeature {
    readonly gameName: string;
    protected audio: AudioManager = null;
    protected resid: ResourceIdentifier = null;
    protected gameResourcesBasePath: string;
    protected jsonSpine: ISkeletonData;
    //protected changeRandomAnimationSpineInterval: IRandomTimeout = null;
    //protected systeContext : SystemContext = null;
    protected startFrecuentlyRandomAnim: ITimeout = null;
    protected startNoFrecuentlyRandomAnim: ITimeout = null;
    protected startPoppetRandomAnim: ITimeout = null;

    constructor(gameName: string, audio: AudioManager, resid: ResourceIdentifier, gameResourcesBasePath: string, systemContext: ISystemContext) {
        this.gameName = gameName;
        this.audio = audio;
        this.resid = resid;
        this.gameResourcesBasePath = gameResourcesBasePath;
        systemContext.CreateSubContext("RandomAnimationFreature");
        this.startFrecuentlyRandomAnim = systemContext.TimingContext().CreateRandomTimeout("startFrecuentlyRandomAnim", 3000, 9000, () => this.StartAnimFrecuently());
        this.startNoFrecuentlyRandomAnim = systemContext.TimingContext().CreateRandomTimeout("startNoFrecuentlyRandomAnim", 10000, 20000, () => this.StartAnimNoFrecuently());
        this.startPoppetRandomAnim = systemContext.TimingContext().CreateRandomTimeout("startPoppetRandomAnim", 15000, 60000, () => this.StartAnimPoppet());
    }


    protected lastindexAnimIntervalFrecuently: number = 0;
    protected currentRandomAnimationIndexFrecuently: number = 0;
    protected StartAnimFrecuently() {
        if(this.debugisActive == true) return
        //let randomRA = this.separatedAudiosFrecuentlyArraySuffle.random();
        //this.audio.Play(this.resid.ScopedResourceName(randomRA));
        //this.spine?.state?.setAnimation(2, randomRA, false);


        if (this.separatedAudiosFrecuentlyArraySuffle.length > 0) {
            this.lastindexAnimIntervalFrecuently = this.currentRandomAnimationIndexFrecuently;
            // if (this.currentRandomAnimationIndexFrecuently == this.separatedAudiosFrecuentlyArraySuffle.length - 1) {
            //     this.separatedAudiosFrecuentlyArraySuffle = shuffle(this.separatedAudiosFrecuentlyArraySuffle);
            // }
            this.currentRandomAnimationIndexFrecuently = (this.currentRandomAnimationIndexFrecuently + 1) % this.separatedAudiosFrecuentlyArraySuffle.length;            
            this.spine?.state?.setAnimation(AnimationRandomIndex.frequently, this.separatedAudiosFrecuentlyArraySuffle[this.currentRandomAnimationIndexFrecuently], false);
            this.audio.Play(this.resid.ScopedResourceName(this.separatedAudiosFrecuentlyArraySuffle[this.currentRandomAnimationIndexFrecuently]));
        }
    }

    protected lastindexAnimIntervalNoFrecuently: number = 0;
    protected currentRandomAnimationIndexNoFrecuently: number = 0;
    protected StartAnimNoFrecuently() {
        if(this.debugisActive == true) return
        if (this.separatedAudiosNoFrecuentlyArraySuffle.length > 0) {
            this.lastindexAnimIntervalNoFrecuently = this.currentRandomAnimationIndexNoFrecuently;
            // if (this.currentRandomAnimationIndexNoFrecuently == this.separatedAudiosNoFrecuentlyArraySuffle.length - 1) {
            //     this.separatedAudiosNoFrecuentlyArraySuffle = shuffle(this.separatedAudiosNoFrecuentlyArraySuffle);
            // }
            this.currentRandomAnimationIndexNoFrecuently = (this.currentRandomAnimationIndexNoFrecuently + 1) % this.separatedAudiosNoFrecuentlyArraySuffle.length;
            this.spine?.state?.setAnimation(AnimationRandomIndex.not_frequently, this.separatedAudiosNoFrecuentlyArraySuffle[this.currentRandomAnimationIndexNoFrecuently], false);
            this.audio.Play(this.resid.ScopedResourceName(this.separatedAudiosNoFrecuentlyArraySuffle[this.currentRandomAnimationIndexNoFrecuently]));
        }
    }


    protected lastindexAnimIntervalPoppet: number = 0;
    protected currentRandomAnimationIndexPoppet: number = 0;
    protected StartAnimPoppet() {
        if(this.debugisActive == true) return;
        if (this.separatedAudiosPoppetArraySuffle.length > 0) {
            this.lastindexAnimIntervalPoppet = this.currentRandomAnimationIndexPoppet;
            // if (this.currentRandomAnimationIndexPoppet == this.separatedAudiosPoppetArraySuffle.length - 1) {
            //     this.separatedAudiosPoppetArraySuffle = shuffle(this.separatedAudiosPoppetArraySuffle);
            // }
            this.currentRandomAnimationIndexPoppet = (this.currentRandomAnimationIndexPoppet + 1) % this.separatedAudiosPoppetArraySuffle.length;
            this.spine?.state?.setAnimation(AnimationRandomIndex.poppet, this.separatedAudiosPoppetArraySuffle[this.currentRandomAnimationIndexPoppet], false);
            this.audio.Play(this.resid.ScopedResourceName(this.separatedAudiosPoppetArraySuffle[this.currentRandomAnimationIndexPoppet]));
        }
    }




    //protected raAudios: string[] = [];
    protected raAudiosTypeJson: AnimationType[] = [];
    ///Anim Ra Frecuently
    protected separatedAudiosFrecuentlyArray: AnimationType[] = [];
    protected separatedAudiosFrecuentlyArraySuffle: string[] = [];
    ///Finish

    //Anim Ra No-Frecuently
    protected separatedAudiosNoFrecuentlyArray: AnimationType[] = [];    
    protected separatedAudiosNoFrecuentlyArraySuffle: string[] = [];

    //Finish
    protected separatedAudiosPoppetArray: AnimationType[] = [];    
    protected separatedAudiosPoppetArraySuffle: string[] = [];
    //Anim

    public ResourcesLoadedGamesPreload(resourceManager: IReadOnlyResourceManager) {
        let propertiesResource = resourceManager?.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(this.gameName + "FillingPotPoppetProperties"));
        //this.raAudios = propertiesResource.json?.["ra_audios"] ?? [];
        this.raAudiosTypeJson = propertiesResource.json?.["ra_Animation_Type"] ?? [];
        this.raAudiosTypeJson = this.raAudiosTypeJson.filter((v) => v.type != AudioRandomType.disabled);
        this.separatedAudiosFrecuentlyArray = this.raAudiosTypeJson.filter((v) => v.type == AudioRandomType.frequently);
        this.separatedAudiosNoFrecuentlyArray = this.raAudiosTypeJson.filter((v) => v.type == AudioRandomType.not_frequently);
        this.separatedAudiosPoppetArray = this.raAudiosTypeJson.filter((v) => v.type == AudioRandomType.poppet);


        //console.log(`${this.gameName}-RandomAnimationFeature-${AudioRandomType.frequently}:`, this.separatedAudiosFrecuentlyArray);
        //console.log(`${this.gameName}-RandomAnimationFeature-${AudioRandomType.not_frequently}:`, this.separatedAudiosNoFrecuentlyArray);
        //console.log(`${this.gameName}-RandomAnimationFeature-${AudioRandomType.poppet}:`, this.separatedAudiosPoppetArray);
    }

    public PrepareResources(resourceManager: IWriteOnlyResourceManager, jsonSpine: ISkeletonData) {

        this.jsonSpine = jsonSpine;
        // add sounds from random animations, this sounds are not required
        let randomAnimations = jsonSpine.animations
            .filter(anim => anim.name.startsWith("RA_"))
            .map(anim => anim.name)

        let wrongAudiosDefind = this.raAudiosTypeJson.filter(audio => !randomAnimations.includes(audio.name));
        if (wrongAudiosDefind.length > 0) {
            for (let a of wrongAudiosDefind) {
                throw new Error(`Audios not defined in spine animations: ${a.name}`);
            }
        }

        let animationsWithAudio: string[] = []
        randomAnimations.filter(anim => this.raAudiosTypeJson.forEach(v => {
            if (v.name == anim) animationsWithAudio.push(anim);
        }));

        for (let ra of animationsWithAudio) {
            this.audio.AddTrack(new Track(`${this.gameResourcesBasePath}FillingPotFeature/tracks/${ra}` + Settings.audioFormat, this.resid.ScopedResourceName(ra), false));
        }
    }


    public ResourcesLoaded(resourceManager: IReadOnlyResourceManager,) {
        let randomAnimations = this.jsonSpine.animations
            .filter(anim => anim.name.startsWith("RA_"))
            .map(anim => anim.name)
            .filter(anim => this.raAudiosTypeJson.includes({
                name: anim,
                type: AudioRandomType.frequently,
                indexAnim : 2
            }))
            .filter(anim => this.raAudiosTypeJson.includes({
                name: anim,
                type: AudioRandomType.not_frequently,
                indexAnim : 3
            }))
            .filter(anim => this.raAudiosTypeJson.includes({
                name: anim,
                type: AudioRandomType.poppet,
                indexAnim : 4
            }));


            

        for (let ra of randomAnimations) {
            console.log(`${this.gameName}-RandomAnimationFeature-track-Name${ra}:`, this.audio.Track(this.resid.ScopedResourceName(ra)), ra);
        }
    }


    protected spine: Spine = null;
    public StartAnimRandom(spine: Spine, clientState : ClientState) {
        if(spine != null )this.spine = spine;
        spine?.state?.data?.skeletonData?.animations.forEach((anim, index) => {
            let spineTrackAnimation: ISpineTrackAnimation = {
                trackAnimationIndex: 0,
                loopAnimation: false,
                soundTrack: null,
                duration: 0,
                animationName: "",
                isActive: false
            }

            if (anim.name.includes("RA_") && this.raAudiosTypeJson.filter(animFilter => animFilter.name == anim.name)) {
                //this.animationArrayRASuffle.push(anim.name);
                spineTrackAnimation.loopAnimation = false;
                spineTrackAnimation.trackAnimationIndex = 2;
                if (this.separatedAudiosFrecuentlyArray.find((v) => v.name == anim.name)) this.separatedAudiosFrecuentlyArraySuffle.push(anim.name);
                else if (this.separatedAudiosNoFrecuentlyArray.find((v) => v.name == anim.name)) this.separatedAudiosNoFrecuentlyArraySuffle.push(anim.name);
                else if (this.separatedAudiosPoppetArray.find((v) => v.name == anim.name)) this.separatedAudiosPoppetArraySuffle.push(anim.name);
            }
            spineTrackAnimation.duration = anim.duration;
            spineTrackAnimation.animationName = anim.name;

        });

        console.log(`${this.gameName}-RandomAnimationFeature-Frecuently:`, this.separatedAudiosFrecuentlyArraySuffle);
        console.log(`${this.gameName}-RandomAnimationFeature-NoFrecuently:`, this.separatedAudiosNoFrecuentlyArraySuffle);
        console.log(`${this.gameName}-RandomAnimationFeature-Poppet:`, this.separatedAudiosPoppetArraySuffle);



        spine?.state?.addListener({
            complete: this.AnimComplete,
            //start: this.StartAnim
        });

        this.startFrecuentlyRandomAnim.Start();
        this.startNoFrecuentlyRandomAnim.Start();  
        if(clientState.Balance() == 0 ) this.startPoppetRandomAnim.Start(); 
        
        this.elementTextDebuggerRA = new Text("", {
            fontFamily: 'NotoSansDisplay-Bold',
            fontSize: Scale.fh(100),
            fontWeight: 'bold',
            fill: ["white"], // gradient
            stroke: 'black',
            strokeThickness: Scale.fh(8),
            //wordWrap: true,			
            lineJoin: 'round',
            //textBaseline : "middle",			
        });

        this.elementTextDebuggerRA.visible = false;
        this.elementTextDebuggerRA.name = "AnimationRandom-LayoutText";
        this.elementTextDebuggerRA.x = Scale.X(19);
        this.elementTextDebuggerRA.y = Settings.ScreenHeight
        this.spine.parent.addChild(this.elementTextDebuggerRA);
    }

    protected AnimComplete = (trackComplete: ITrackEntry) => {
        trackComplete.animation.name
        if (this.separatedAudiosFrecuentlyArray.find((v) => v.name == trackComplete.animation.name) || this.separatedAudiosNoFrecuentlyArray.find((v) => v.name == trackComplete.animation.name) || this.separatedAudiosPoppetArray.find((v) => v.name == trackComplete.animation.name)) {
            this.spine?.state?.clearTrack(trackComplete.trackIndex);
            //debugger
            if (this.separatedAudiosFrecuentlyArray.find((v) => v.name == trackComplete.animation.name)) {
                this.startFrecuentlyRandomAnim.Start();
                //console.log(`${AudioRandomType.frequently}-RandomAnimClear-${trackComplete.animation.name}:`,)
            }
            else if (this.separatedAudiosNoFrecuentlyArray.find((v) => v.name == trackComplete.animation.name)) {
                this.startNoFrecuentlyRandomAnim.Start();
                //console.log(`${AudioRandomType.not_frequently}-RandomAnimClear-${trackComplete.animation.name}:`,)
            }
            else if (this.separatedAudiosPoppetArray.find((v) => v.name == trackComplete.animation.name)) {
                this.startPoppetRandomAnim.Start();
                //console.log(`${AudioRandomType.poppet}-RandomAnimClear-${trackComplete.animation.name}:`,)
            };
        }
    }

    public Destroy(){
        this.startFrecuentlyRandomAnim.Stop();
        this.startNoFrecuentlyRandomAnim.Stop();
        this.startPoppetRandomAnim.Stop();
        this.separatedAudiosFrecuentlyArraySuffle = [];
        this.separatedAudiosNoFrecuentlyArraySuffle = [];
        this.separatedAudiosPoppetArraySuffle = [];
        this.debugisActive = false;        
        Safe(() => { this.elementTextDebuggerRA.destroy({children: true, texture: true, baseTexture: true})});
    }

    public StartRAPoppet(){
        this.startPoppetRandomAnim.Start();
    }

    public StopsRAPoppet(){
        this.startPoppetRandomAnim.Stop();
    }

    protected debugisActive : boolean = false;
    protected elementTextDebuggerRA: Text = null;
    public FillingPotDebuggerRAAnimationDebugger(numberAnimToPlay: string) {        
        this.debugisActive = true;
        if(this.debugisActive == true) this.elementTextDebuggerRA.visible = true;
        this.startPoppetRandomAnim.Stop();
        this.startFrecuentlyRandomAnim.Stop();
        this.startNoFrecuentlyRandomAnim.Stop();
        let indexRA = parseInt(numberAnimToPlay) - 1;
        if (indexRA < this.raAudiosTypeJson.length && this.raAudiosTypeJson[indexRA].type != AudioRandomType.disabled) {
            console.log("RandomAnimationFeature-AnimationRATOPlay:", this.raAudiosTypeJson[indexRA].name);            
            this.spine?.state?.setAnimation(AnimationRandomIndex[this.raAudiosTypeJson[indexRA].type] , this.raAudiosTypeJson[indexRA].name , false);
            this.audio.Play(this.resid.ScopedResourceName(this.raAudiosTypeJson[indexRA].name));
            this.elementTextDebuggerRA.text = this.raAudiosTypeJson[indexRA].name;
        } else {            
            this.elementTextDebuggerRA.text = `RA_Anim Dose't exist change index , \navailablesRA availables: ${this.raAudiosTypeJson.length}`;
            console.log("RA_Anim Dose't exist , change index , availablesRA availables:", this.raAudiosTypeJson.length);
        }
        setTimeout(() => { this.elementTextDebuggerRA.text = "" }, 1000)
    }
}